<template>
  <v-dialog
    width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
    v-model="opened"
  >
    <v-card flat>
      <v-card-text class="align-center">
        <v-icon class="success--text" size="50">thumb_up</v-icon>
        <v-layout
          column
          align-center
          class="subheading pa-2 success--text font-weight-bold"
        >
          Well Done!
        </v-layout>
        <v-divider class="my-3" />
        <v-layout column align-center>
          You've successfully completed
          {{ currentQuestionnaire.tax_year }}
          {{ currentQuestionnaire.formatted_name }}!
        </v-layout>
        <v-divider class="my-3" />
        <v-layout align-center>
          <v-btn
            outline
            block
            color="primary"
            class="text-none mr-2"
            @click="$emit('go-to-dashboard')"
          >
            {{ userSignedIn ? 'View Dashboard' : 'Login to View Dashboard' }}
          </v-btn>
          <v-btn
            outline
            block
            color="error"
            class="text-none ml-2"
            @click="$emit('update:opened', false)"
            v-if="currentUser && currentUser.is_advisor"
          >
            Close
          </v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    opened: {
      type: Boolean,
    },

    currentQuestionnaire: {
      type: Object,
    },

    userSignedIn: {
      type: Boolean,
    },

    currentUser: {
      type: Object,
    },
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      currentFirm: 'currentFirm',
    }),
  },

  methods: {},
};
</script>
